import React from 'react'

import classnames from 'classnames'

import { bool, number, string } from 'prop-types'

const Row = ({ colNum, gapSize, inline, className, children }) => {
  const classNameVal = classnames('cmps-row', className, {
    'cmps-row--inline': inline,
  })

  return (
    <div className={classNameVal}>
      { children }
      <style jsx>
        {`
          .cmps-row {
            display: grid;
            grid-template-columns: repeat(${colNum}, 1fr);
            grid-gap: ${gapSize}px;
          }
        `}
      </style>
    </div>
  )
}

Row.propTypes = {
  colNum: number,
  gapSize: number,
  inline: bool,
  className: string,
}

Row.defaultProps = {
  colNum: 12,
  gapSize: 16,
  inline: false,
}

export default Row
